const company = {
  Company: "Company",
  Details: "Details",
  "Company Details": "Company Details",
  "Registered Business Name": "Registered Business Name",
  "Country of Registration": "Country of Registration",
  "Tax ID": "Tax ID",
  "Registered Address": "Registered Address",
  "Street Address Line 1": "Street Address Line 1",
  "Street Address Line 2": "Street Address Line 2",
  City: "City",
  State: "State",
  Postcode: "Postcode",
  Country: "Country",
};

export default company;
